import { FileTypes } from '../enums/file-types';

export class FileUtil {
  public static getExtFromFileName(filename: string): string {
    var lastPeriod = filename.lastIndexOf('.');
    if (lastPeriod > -1) {
      const split = filename.split('.');
      return split[split.length - 1].toLowerCase();
    } else {
      return null;
    }
  }

  public static getFileTypeFromName(fileName: string): FileTypes {
    let type: FileTypes;
    const ext: string = this.getExtFromFileName(fileName);
    switch (ext) {
      case 'jpg':
      case 'jfif':
      case 'png':
      case 'gif':
      case 'jpeg':
      case 'tiff':
        type = FileTypes.IMAGE;
        break;

      case 'webm':
        type = FileTypes.AUDIO;
        break;

      case 'doc':
      case 'docx':
        type = FileTypes.WORD;
        break;

      case 'xls':
      case 'xlsx':
        type = FileTypes.EXCEL;
        break;

      case 'ppt':
      case 'pptx':
        type = FileTypes.POWERPOINT;
        break;

      case 'pdf':
        type = FileTypes.PDF;
        break;

      case 'eps':
        type = FileTypes.EPS;
        break;

      case 'psd':
        type = FileTypes.PSD;
        break;

      case 'ai':
        type = FileTypes.AI;
        break;

      default:
        type = FileTypes.DATA;
        break;
    }
    return type;
  }
}
